(function ($) {
	'use strict';

	$('.touch-enabled').parent().css('position','relative').append('<div class="touch-enabled__overlay"><div class="touch-enabled__button"></div></div>');

	$('body').on('click touch', '.touch-enabled__overlay', function () {
		$(this).addClass('touched');
	})
})(jQuery);
